import React from 'react';
import { connect } from 'react-redux';

import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';
import { useIntl } from 'react-intl';
import { getPartiesWithSigners } from '~/reducers/workflow';
import Box from '~/ui/components/Box/Box';
import { getFieldDefinitionStatus } from '~/utils/workflow';

import RadioItem from './RadioItem';

function RadioPartiesWithSigners({
  selectedFieldDefinition,
  selectedEntity,
  onClick,
  //connected
  fieldLinks,
  parties,
}) {
  const { counter, internal } = parties;
  const isPartyFieldDefinition = selectedFieldDefinition?.entity === 'party';
  const isSignerFieldDefinition = !isPartyFieldDefinition;
  const intl = useIntl();

  function renderParties(parties) {
    return parties.map((party) => {
      const { id, name, signers } = party;
      const { isSelected, isUsed, tooltip } = getFieldDefinitionStatus({
        entityId: id,
        fieldDefinition: selectedFieldDefinition,
        fieldLinks,
        selectedEntityId: selectedEntity?.id,
        selectedFieldDefinition,
        intl,
      });
      return (
        <Box key={id}>
          <Tooltip
            tooltip={isPartyFieldDefinition && isUsed ? tooltip : undefined}
          >
            <RadioItem
              disabled={isSignerFieldDefinition || isUsed}
              option={{ label: name, value: id }}
              selected={isSelected}
              onClick={() => onClick(party)}
            />
          </Tooltip>
          {signers.map((signer) => {
            const { id, name } = signer;
            const { isSelected, isUsed, tooltip } = getFieldDefinitionStatus({
              entityId: id,
              fieldDefinition: selectedFieldDefinition,
              fieldLinks,
              selectedEntityId: selectedEntity?.id,
              selectedFieldDefinition,
              intl,
            });
            return (
              <Tooltip
                key={id}
                tooltip={
                  isSignerFieldDefinition && isUsed ? tooltip : undefined
                }
              >
                <RadioItem
                  disabled={isPartyFieldDefinition || isUsed}
                  indent={2}
                  option={{ label: name, value: id }}
                  selected={isSelected}
                  onClick={() => onClick(signer)}
                />
              </Tooltip>
            );
          })}
        </Box>
      );
    });
  }

  return (
    <Box>
      {renderParties(internal)}
      <Box bg="gray-400" mx={6} my={3} sx={{ height: '1px' }} />
      {renderParties(counter)}
    </Box>
  );
}

const mapStateToProps = ({ workflow }) => ({
  parties: getPartiesWithSigners(workflow),
  fieldLinks: workflow.fieldLinks,
});

export default connect(mapStateToProps)(RadioPartiesWithSigners);
